module.exports = __webpack_public_path__ + "static/img/packaged-oil_256.9019c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-oil_256.png
// module id = vCff
// module chunks = 0